import BasicDialog from "../components/gt/shared/BasicDialog";
export default {
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },

  components: {
    BasicDialog,
  },

  computed: {
    title() {
      return this.value && this.value.id
        ? `Edit ${this.itemTypeLabel}`
        : `New ${this.itemTypeLabel}`;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/BasicEditDialog.js